/* global APP_RELEASE_STAGE, APP_FULL_VERSION */
import "@babel/polyfill"
// for ie 10, fix undefined api url
import "location-origin"
// for ie, fix new URL()
import "url-polyfill"

import Vue from 'vue'
// import { $, jQuery } from 'jquery'
import VueGlobalEmitter from 'vue-global-emitter'
Vue.use(VueGlobalEmitter, {debug: false});
import VueSweetalert2 from 'vue-sweetalert2'
import ProgressBar from './components/progress-bar/progress-bar.vue'
import {PERMS} from './config/permissions.js'
import asyncDataHelper from "./utils/asyncDataHelper"
import {DEFAULT_REDIRECT, HIDDEN_ROUTES_FOR_REGISTERED} from './config/config.js'
import {ROOT_API, REGION_ROOT_API} from "./config/config"
import {LOCALE} from "./config/locale"
import url from "./utils/url"

// set lang
import {getTranslateInstance, InstallTranslate} from "./utils/translate"
const translate = getTranslateInstance();
translate.setLocalization(LOCALE);
Vue.use(InstallTranslate);

// init error monitor
// account: gabrdashitov.r@etton.ru
import region from './utils/region'
const bugsnag = require('bugsnag-js');
// set development stage on developers PC
const bugTrackerReleaseStage = (function () {
  let stage = 'development';
  let roots = Object.values(REGION_ROOT_API);
  if (APP_RELEASE_STAGE === 'production' && roots.indexOf(ROOT_API) > -1) {
    stage = 'innerProduction'
  }
  return stage
}());
console.warn('bugTrackerReleaseStage', bugTrackerReleaseStage);
if (bugTrackerReleaseStage === 'innerProduction') {
  const bugsnagClient = bugsnag({
    apiKey: '8d5fbc87162115837d88fdc855286447',
    appVersion: APP_FULL_VERSION,
    releaseStage: bugTrackerReleaseStage,
    metaData: {
      region: region.getCurrentRegion()
    },
    autoCaptureSessions: false,
    consoleBreadcrumbsEnabled: false
  });
  const bugsnagVue = require('bugsnag-vue');
  bugsnagClient.use(bugsnagVue(Vue));
  Vue.prototype.$bugsnagClient = bugsnagClient
}
// yandex metrika for karelia
if (region.getCurrentRegion() === 'karel' && process.env.NODE_ENV === 'production') {
  (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
   m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

   ym(54066238, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
   });
}

// needed for jquery and plugins in dev mode
var $ = require('jquery');
window.jQuery = $;
window.$ = $;
import 'suggestions-jquery/dist/css/suggestions.min.css'

import App from './app/app/App.vue'
import router from './routes/index'
import store from './store/index'
import {registerWorker} from './registerServiceWorker'

import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'

// element-ui http://element.eleme.io/#/en-US/component
import Element from 'element-ui'
Vue.use(Element);
import 'element-ui/lib/theme-chalk/index.css'

import GlobalComponents from './components/components.js'
Vue.use(GlobalComponents);

import CommonComponents from './common/common-components.js'
Vue.use(CommonComponents);

import AppComponents from './app/components.js'
Vue.use(AppComponents);

// стили приложения
import './assets/styles/mainstyle.scss'

Vue.use(VueSweetalert2);

import Preloader from './components/preloader/preloader'
Vue.component('preloader', Preloader);

import PagePreloaderComponent from './components/preloader/page-preloader'
Vue.component('page-preloader', PagePreloaderComponent);
let PagePreloader = Vue.extend(PagePreloaderComponent);
const pagePreloader = Vue.prototype.$pagePreloader = new PagePreloader({store}).$mount();
document.body.appendChild(pagePreloader.$el);

const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount();
document.body.appendChild(bar.$el);


// global this.$e methods
import {installE} from './utils/e'
Vue.use(installE);

import titleMixin from './mixins/title-mixin.js'
Vue.mixin(titleMixin);

import stringFilters from './filters/string.js'
import {dateToUnixTime, unixTimeToDate} from './filters/time.js'
Vue.filter('cut', stringFilters.cut);
Vue.filter('stripHtml', stringFilters.stripHtml);
Vue.filter('firstLetterCapital', stringFilters.firstLetterCapital);
Vue.filter('dateToUnixTime', dateToUnixTime);
Vue.filter('unixTimeToDate', unixTimeToDate);

// export global diretives
import elementRerender from './directives/element-rerender'
import arrayAsLine from './directives/array-as-line'
Vue.directive('e-element-rerender', elementRerender);
Vue.directive('e-array-as-line', arrayAsLine);

// a global mixin that calls `asyncData` when a route component's params change
Vue.mixin({
  methods: {
    lockRoute () {
      this.routeLocked = true
    },
    unLockRoute () {
      this.routeLocked = false
    },
    routeIsLocked () {
      return this.routeLocked === true
    }
  },
  beforeRouteUpdate (to, from, next) {
    // skip on router.replace()
    if (this.$router.isReplace) {
      next();
      return
    }

    // skip, use in map and others modules
    if (this.$store.getters.skipAsyncData(to.name)) {
      next();
      return
    }
    this.lockRoute();
    const {asyncData} = this.$options;
    bar.start();
    if (asyncData) {
      asyncData({
        store: this.$store,
        route: to,
        fromRoute: from,
        methods: this,
        ctx: this
      }).then(() => {
        if (to.name && to.name !== 'main.error') {
          this.$store.commit('mutateError', null)
        }
        bar.finish();
        next();
        this.unLockRoute()
      }).catch(() => {
        bar.finish();
        next();
        this.unLockRoute()
      })
    } else {
      /* if (to.name && to.name !== 'main.error') {
        this.$store.commit('mutateError', null)
      } */
      bar.finish();
      next();
      this.unLockRoute()
    }
  }
});

if (process.env.NODE_ENV === 'production') {
  /* Vue.config.errorHandler = function (err, vm, info) {
    console.error(info)
    console.info(vm)
    store.commit('mutateError', {
      response: {
        status: 100,
        statusText: translate.translate('Ошибка выполнения приложения'),
        message: info.toString()
      }
    })
  } */
}

router.onError(error => {
  console.error(error);
  let msg = translate.translate('Ошибка навигации ');
  let from = '';
  let to = '';
  let nextUrl = null;
  if (router.history.pending && router.history.pending.name) {
    to = router.history.pending.name;
    msg += translate.translate(' при разрешении маршрута ') + to;
    nextUrl = url.getRoute(router.history.pending, true)
  }
  if (router.history.current && router.history.current.name) {
    from = router.history.current.name;
    msg += translate.translate(' на маршруте ') + from
  }
  Vue.prototype.$bugsnagClient && Vue.prototype.$bugsnagClient.notify({
    name: 'Route error from ' + from + ' to ' + to,
    message: error.message,
    fileName: error.fileName,
    lineNumber: error.lineNumber
  });
  try {
    msg += ' <div><code>' + error.toString() + '</code></div> '
  } catch (e) {
    msg += ' <div><code>' + e.toString() + '</code></div> '
  }
  msg += '<div class="error-tip">' + translate.translate('T_CHUNK_ERROR') + '</div>';
  store.commit('mutateError', new Error(msg));
  bar.finish();
  // for dont block go back, redirect
  router.push({name: 'main.error', query: {reason: 'chunk', nextUrl}})
});

router.beforeEach((to, from, next) => {
  let blackList = HIDDEN_ROUTES_FOR_REGISTERED;
  if (to.meta && to.meta.requiresAuth === false) {
    if (blackList.indexOf(to.name) > -1) {
      if (store.getters.isGuest === false) {
        next(DEFAULT_REDIRECT.user);
        return
      }
    }
    next()
  } else {
    if (store.getters.isGuest) {
      if (blackList.indexOf(to.name) === -1) {
        store.commit('userSetRedirectUrl', url.getRoute(to))
      }
      next(DEFAULT_REDIRECT.guest)
    } else {
      if (store.getters.userCan(PERMS.VIEW, {route: to, router: router})) {
        next()
      } else {
        let name = '';
        if (to.meta && to.meta.title) {
          name = to.meta.title
        }
        store.commit('mutateError', new Error(translate.translate('Нет прав на просмотр раздела ') + name));
        next({name: 'main.error', query: {reason: 'forbidden'}})
      }
    }
  }
});

Vue.config.productionTip = true;

// wait until router has resolved all async before hooks
// and call async function
// router.onReady(() => {
// Add router hook for handling asyncData.
// Doing it after initial route is resolved so that we don't double-fetch
// the data that we already have. Using router.beforeResolve() so that all
// async components are resolved.
router.beforeResolve((to, from, next) => {

  const matched = router.getMatchedComponents(to);
  const prevMatched = router.getMatchedComponents(from);
  let diffed = false;
  const activated = matched.filter((c, i) => {
    return diffed || (diffed = (prevMatched[i] !== c))
  });
  if (!activated.length) {
    return next()
  }

  if (to.name && to.name === 'main.error' && store.getters.getError === null) {
    if (to.query.nextUrl) {
      return next(url.encode(to.query.nextUrl))
    }
    return next({path: '/'})
  }

  bar.start();
  Promise.all(
    activated.map(c => asyncDataHelper.handleAsyncData(c, {store, from, to}))
  ).then(() => {
    if (to.name && to.name !== 'main.error') {
      store.commit('mutateError', null)
    }
  }).finally(() => {
    bar.finish();
    next()
  })
});

// save store and router, for share
// with main instance and single components on map
Vue.prototype.$sharedServices = {
  store,
  router
};

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
});

// register service worker, for use as PWA
registerWorker({bar, store, notify: Vue.prototype.$notify, translate, emitter: Vue.prototype.$emitter});
// if dont use pwa uncomment line below
// bar.unLockAppBootstrap()

// })
